module.exports = {"title":"SystemMaintenance","content":"CMHK system is under maintenance since 9-Dec-2020 23:30 - 10-Dec-2020 07:00, service will be suspended during the period including Account Login, Bill Payment, Prepaid Card Refill, International Roaming, Purchase Extra Data, VAS Subscription, Service Plan Upgrade and other telecom services. In emergency, please contact CMHK 24 hrs Hotline 29458888, we’re sorry for inconvenience caused."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/SystemMaintenance/en.json
// module id = N5Bm
// module chunks = 1